import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import {
  Box
} from '@material-ui/core';

import QuickSaleDisplay from 'components/QuickSale/QuickSaleDisplay';

import { standard } from 'variables/userAccountTypes';

const mapStateToProps = (state) => ({
  activeUserId: state.activeUserId,
  activeUserType: state.activeUserType,
  customers: state.customers,
  products: state.products,
  idGen: state.idGen,
  user: state.user
});

const QuickSale = (props) => {

  const createSODisplayId = () => {
    const length = props.idGen.find(idGen => idGen.info.user === props.activeUserId).body.salesOrder;
    let salesNum;
    length < 100 ? 
      salesNum = new Array(3 + 1 - (length + '').length).join('0') + length
    : salesNum = length
    return ("SO-" + salesNum);
  };

  const createCustomerDisplayId = () => {
    let length;
    props.activeUserType === standard ?
      length = props.idGen.find(idGen => idGen.info.user === props.user.adminId).body.customer
    : length = props.idGen.find(idGen => idGen.info.user === props.activeUserId).body.customer

    let customerNum;
    length < 100 ? 
      customerNum = new Array(3 + 1 - (length + '').length).join('0') + length
    : customerNum = length
    return ("C-" + customerNum);
  };

  return (
    <>
      <Helmet>
        <title>Quick Sale | Duot One</title>
      </Helmet>
      <Box>
        <QuickSaleDisplay
          activeUserId={props.activeUserId}
          activeUserType={props.activeUserType}
          customers={props.customers}
          products={props.products}
          user={props.user}
          createSODisplayId={createSODisplayId}
          createCustomerDisplayId={createCustomerDisplayId}
        />
      </Box>
    </>
  )
};

export default connect (mapStateToProps) (QuickSale);